import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { SecuredSessionEncodedData } from '../models/auth/secured-session-encoded-data.model';
import { AuthenticationService } from './authentication.service';

@Injectable({ providedIn: 'root' })
export class SsoResolver implements Resolve<SecuredSessionEncodedData> {
    constructor(private authService: AuthenticationService) {}

    resolve(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): Observable<SecuredSessionEncodedData> | Promise<SecuredSessionEncodedData> | SecuredSessionEncodedData {
        const ssoId = route.paramMap.get('ssoId');

        const returnUrl = route.queryParamMap.get('route');

        if (returnUrl.includes('cf-signature-qr')) {
            this.authService.isQrSignatureRoute = true;
        }

        return new Promise((resolve, reject) => {
            this.authService.getSessionEncodedData(ssoId).subscribe((encodedJwt: SecuredSessionEncodedData) => {
                resolve(encodedJwt);
            });
        });
    }
}
